export const CONTA_CLIENTE = 'Conta Corrente de Cliente';
export const NOVO = 'Novo Lançamento';
export const EDITAR = 'Editar Lançamento';
